import script from "./LiveCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveCalendar.vue?vue&type=script&setup=true&lang=js"

import "./LiveCalendar.vue?vue&type=style&index=0&id=55f5cc37&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55f5cc37"]])

export default __exports__